<template>
  <g>
    <path
      fill="#32BEA6"
      d="M63 126c34.794 0 63-28.206 63-63S97.794 0 63 0 0 28.206 0 63s28.206 63 63 63z"
    />
    <path
      fill="#fff"
      d="M91.784 36.54H35.477c-3.582 0-6.496 2.967-6.496 6.615v39.69c0 3.648 2.914 6.615 6.496 6.615h56.307c3.582 0 6.496-2.967 6.496-6.615v-39.69c0-3.648-2.914-6.615-6.496-6.615zm0 4.41c.294 0 .574.062.83.17L63.63 66.698 34.647 41.121c.256-.109.536-.171.83-.171h56.307zm0 44.1H35.477c-1.194 0-2.165-.988-2.165-2.205V45.78l28.9 25.502c.408.36.913.538 1.418.538.506 0 1.011-.179 1.42-.538l28.9-25.502v37.065c0 1.217-.972 2.205-2.166 2.205z"
    />
  </g>
</template>

<script>
export default {
  name: 'circleEmail'
}
</script>

<style scoped></style>
